import type { ActionItemProps } from "./ActionItem"
import { ActionItem } from "./ActionItem"

type ActionItemResponsiveProps = Omit<ActionItemProps, "hideLabel">

export const ActionItemResponsive = (props: ActionItemResponsiveProps) => (
	<ActionItem hideLabel={{ base: true, xs: false }} {...props} />
)
